import * as React from 'react';
import { Breadcrumb, Typography } from 'antd';
import SearchInput from './SearchInput/SearchInput.jsx';
import styles from './index.module.less';

const { Title, Paragraph } = Typography;

export default function ImgContainer({
  onChangeKeyword,
  onChangeFlag,
  onChangeSelectedIndustry,
}) {
  return (
    <div className={styles.top_banner}>
      <Breadcrumb
        style={{
          borderBottom: '1px solid #f0f0f0',
        }}
        items={[
          {
            title: '首页',
          },
          {
            title: ' 支持',
          },
          {
            title: '资源中心',
          },
        ]}
      />
      <Typography>
        <Title className={styles.title}>资源中心</Title>
        <Paragraph className={styles.description}>
          获取最新的InHand设备文档、固件和开发工具，随时掌握最新信息。
        </Paragraph>
      </Typography>
      <SearchInput
        onChangeKeyword={onChangeKeyword}
        onChangeFlag={onChangeFlag}
        onChangeSelectedIndustry={onChangeSelectedIndustry}
      />
    </div>
  );
}
